export interface FicheroLote {
  id: string;
  nombre: string;
  mime: string;
  base64: string;
  firmadoB64?: string;
  error?: string;
}

/** Texto de rúbrica igual al diálogo de AutoFirma (una sola línea: en lote "\\n" corta el parámetro). */
const LAYER2_TEXT =
  'Firmado por $$SUBJECTCN$$ el $$SIGNDATE=dd/MM/yyyy$$ con un certificado emitido por $$ISSUERCN$$';

/**
 * Extra params PAdES para que Autofirma pinte la rúbrica (si no, la firma es invisible).
 * Coordenadas PDF (origen abajo-izquierda), última página, abajo a la derecha.
 * Recuadro más ancho para que quepa el texto completo (Courier 12, como AutoFirma).
 */
export function extraParamsFirmaVisiblePades(): string {
  return [
    'visibleSignature=true',
    'signaturePage=-1',
    'signaturePositionOnPageLowerLeftX=200',
    'signaturePositionOnPageLowerLeftY=30',
    'signaturePositionOnPageUpperRightX=575',
    'signaturePositionOnPageUpperRightY=140',
    'allowSigningCertifiedPdfs=true',
    'allowCosigningUnregisteredSignatures=true',
    'layer2FontSize=12',
    'layer2FontColor=black',
    'layer2FontFamily=1',
    'layer2Text=' + LAYER2_TEXT
  ].join('\n');
}

export interface ResultadoFirmaLote {
  id: string;
  ok: boolean;
  data?: string;
  error?: string;
}

function asList(result: any): any[] {
  if (!result) return [];
  if (Array.isArray(result)) return result;
  if (Array.isArray(result.signs)) return result.signs;
  if (Array.isArray(result.singlesigns)) return result.singlesigns;
  return [];
}

function isOk(item: any): boolean {
  const value = (item?.result || item?.ok || '').toString().toUpperCase();
  if (value === 'FALSE' || value === 'ERROR' || value.startsWith('ERROR')) return false;
  if (item?.ok === false) return false;
  return !!(item?.data || item?.sig || item?.signature || value === 'OK' || value.includes('DONE') || item?.ok === true);
}

/** Interpreta la respuesta JSON de AutoFirma signBatch. */
export function parseLoteResult(result: any, failMsg = 'No se pudo firmar'): ResultadoFirmaLote[] {
  if (typeof result === 'string') {
    try {
      return parseLoteResult(JSON.parse(result), failMsg);
    } catch {
      return [];
    }
  }
  return asList(result).map((item) => {
    const id = item?.id != null ? String(item.id) : '';
    const data = item?.data || item?.sig || item?.signature;
    const ok = isOk(item) && !!data;
    return {
      id,
      ok,
      data: data || undefined,
      error: ok ? undefined : (item?.description || item?.error || failMsg)
    };
  });
}

export function aplicarResultadoLote(
  ficheros: FicheroLote[],
  resultados: ResultadoFirmaLote[],
  noResultMsg = 'Sin resultado en el lote'
): FicheroLote[] {
  const byId = new Map(resultados.map((r) => [r.id, r]));
  return ficheros.map((f) => {
    const r = byId.get(f.id);
    if (!r) return { ...f, error: noResultMsg };
    if (!r.ok) return { ...f, firmadoB64: undefined, error: r.error };
    return { ...f, firmadoB64: r.data, error: undefined };
  });
}
